import { IWeek } from '../types';
import { TimeHelper } from '../../../utils';
import { getWeekByDate } from './getWeekByDate';

export function getWeeksToAppend(weeks: IWeek[], count: number, timezone: string): IWeek[] {
  if (weeks.length === 0) return [];

  const lastWeek = weeks[weeks.length - 1];
  const startOfNextWeek = TimeHelper.addWeeks(lastWeek.endDate, 1, timezone);
  const result: IWeek[] = [];

  for (let weeksOffset = 0; weeksOffset < count; weeksOffset += 1) {
    const startOfWeek = TimeHelper.addWeeks(startOfNextWeek, weeksOffset, timezone);
    const week = getWeekByDate(startOfWeek, timezone);
    result.push(week);
  }

  return result;
}
